module.exports = __webpack_public_path__ + "static/media/defi-dark-circular.72fd0d02.png";